import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { updateMatchResult } from 'features/match/thunks';

import ActionLink from 'styled/components/ActionLink';
import TextInput from 'styled/components/TextInput';

import { StyledResultInput } from './StyledHeader';
import returnZeroIfNotDefined from 'helpers/returnZeroIfNotDefined';
import { useAppDispatch } from '../../hooks/hooks';

const ResultInput: React.FC = () => {
  const dispatch = useAppDispatch();
  const [showResultInput, setShowResultInput] = useState(false);
  const [resultInput, setResultInput] = useState('');

  const updateRegex = /^\d{0,2}(-)?\d{0,2}$/;
  const submitRegex = /^\d{1,2}-\d{1,2}$/;

  const invalid = !submitRegex.test(resultInput);

  const updateInput = (event: any) => {
    const { value } = event.target;

    if (updateRegex.test(value)) setResultInput(value);
  };

  const submit = () => {
    const [home, away] = resultInput.split('-').map(Number).map(returnZeroIfNotDefined);

    if (invalid) return;

    dispatch(
      updateMatchResult({
        home,
        away,
      }),
    );

    setShowResultInput(false);
  };

  if (showResultInput) {
    return (
      <StyledResultInput>
        <TextInput
          tiny
          type="string"
          onChange={updateInput}
          value={resultInput}
          onKeyUp={(event) => {
            if (event.key === 'Enter') {
              submit();
            } else if (event.key === 'Escape') {
              setShowResultInput(false);
            }
          }}
          autoFocus
        />
        <ActionLink onClick={submit} disabled={invalid}>
          Ok
        </ActionLink>
      </StyledResultInput>
    );
  }

  return (
    <StyledResultInput>
      <ActionLink onClick={() => setShowResultInput(true)}>
        <FormattedMessage id="header.setResult" />
      </ActionLink>
    </StyledResultInput>
  );
};

export default ResultInput;
